import { AccessPermissionType } from "./accessPermisionType";
import { Dossier } from "./dossier";
import { Fichier } from "./fichier";

export class WorkflowEtapeInstance {
  workflowEtapeInstanceId: number;
  nom: string;
  numeroOrdre: number;
  fichiers: Fichier[];
  dossier: Dossier;
  dossierId: number;
  estRenseignee: boolean;
  accessPermission: AccessPermissionType = AccessPermissionType.NONE;


  
}
